<gbp-spinner [visible]="(loading$ | async) ? true : false"></gbp-spinner>
<gbp-toast></gbp-toast>
<router-outlet></router-outlet>